module.exports = __webpack_public_path__ + "media/images/top/flow04-e1aba3d881a76c938023db77d3f2051b.jpg";